import { array, partial, string } from 'io-ts/Decoder';

import { Id as BuilderId } from '../../builder/Id';
import { Id as CustomerId } from '../../customer/Id';
import { Id as AllocationTypeId } from '../../job/allocation-type/Id';
import { Id as RequirementId } from '../../job/requirement/Id';
import { Id as OrganizationId } from '../../organization/Id';
import { Id as ProjectId } from '../../project/Id';
import { DateFilter } from '../../ui/filter/DateFilter';
import { ListFilter } from '../../ui/filter/ListFilter';
import { Id as UserId } from '../../user/Id';

import { AdditionalFilterFormField } from './FilterFormField';

export const SettingsFilters = partial({
	searchTerm: string,
	//
	organization: ListFilter(OrganizationId),
	allocationType: ListFilter(AllocationTypeId),
	status: ListFilter(string),
	more: array(AdditionalFilterFormField),
	//
	builder: ListFilter(BuilderId),
	project: ListFilter(ProjectId),
	customer: ListFilter(CustomerId),
	type: ListFilter(string),
	requirements: ListFilter(RequirementId),
	createdAt: DateFilter,
	createdBy: ListFilter(UserId),
	owner: ListFilter(UserId),
	targetAt: DateFilter,
	dueAt: DateFilter,
	assignedTo: ListFilter(UserId),
	salesPerson: ListFilter(UserId),
});
